<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="white"
  >
    
    <div class="container">
      <nav>
        <ul>
          <li>
            <router-link v-popover:popover1 to="/provider">
              Provider
            </router-link>
          </li>
          <li>
            <router-link v-popover:popover1 to="/privacy">
              Privacy
            </router-link>
          </li>
        </ul>
      </nav>
      <div style="text-align:right">
        &copy; {{ year }} Crowdify. <br>All Rights Reserved.
      </div>
    </div>


  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
